// Introduction Reducer

const introductionReducerDefaultState = {
    profile: { 
        introJson: {
            name:{},
            summary:'',
            summaryBullets:[]
        },
        socialLinks: []
    }
};

export default (state = introductionReducerDefaultState, action) => {
   // console.log('Intro reducer 11 : ', action);
  //  console.log('Intro reducer 2: ', state);

    switch (action.type) {

        case 'INTRODUCTION':
            return {
                ...state,
                profile: action.profile
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/introduction.js